import React from 'react';
import { useRouteMatch} from 'react-router-dom';
import {Route, Switch} from "react-router-dom";
import TeacherLessons from "./TeacherLessons";
import UploadedLessons from "./UploadedLessons";

export default function TeacherLesson() {
    let { path } = useRouteMatch();
    return (
        <Switch>
            <Route exact path={path}  component={TeacherLessons} />
            <Route path={`${path}/uploaded-lessons`} component={UploadedLessons}  />
        </Switch>
    )
}
